<template>
  <!--   Main Content Start Here   -->
  <main>
    <div v-if="loader">
      <div class="spinner"></div>
    </div>
    <section class="dashboard_wraper">
      <div class="container_large">
        <div class="row">
          <!-- starting side bar -->
          <sidebar-component></sidebar-component>
          <!-- ending sidebar  -->
          <div class="col-md-12 col-lg-9">
            <div class="dashboard_card">
              <h2>Payment Method</h2>
              <div class="account_form">
                <form method="" action="" @submit.prevent="WalletAction()">
                  <div class="row">
                    <div
                      class="alert alert-success alert-dismissible"
                      v-if="status && status.success && status.success == 200"
                    >
                      <strong>Success!</strong> Action performed successfully.
                    </div>
                    <div
                      class="alert alert-danger alert-dismissible"
                      v-if="status && status == 500 && stripe_error"
                    >
                      <strong>Failed!</strong> {{ stripe_error }}.
                    </div>
                    <div class="col-md-6">
                      <div class="form_group">
                        <label>Card Number</label>
                        <input
                          type="text"
                          name=""
                          v-model="formObj.card_number"
                          placeholder="XXXX XXXX XXXX XXXX"
                          autofocus
                          required
                        />
                        <v-errors :errors="errorFor('card_number')"></v-errors>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form_group">
                        <label>Expiry Date</label>
                        <input
                          type="text"
                          name=""
                          placeholder="MM/YYYY"
                          v-model="formObj.card_expiry"
                        />
                        <v-errors :errors="errorFor('card_expiry')"></v-errors>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form_group">
                        <label>CVV</label>
                        <input
                          type="text"
                          name=""
                          placeholder="XXX"
                          v-model="formObj.card_cvv"
                        />
                        <v-errors :errors="errorFor('card_expiry')"></v-errors>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="order_buttons">
                      <input
                        type="submit"
                        class="button primary_button"
                        value="Save"
                      />
                    </div>
                  </div>
                  <hr />
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
  <!--   Main Content End Here   -->
</template>
<script>
import sidebarComponent from "./sidebar";
import { is422 } from "../../utils/response";
import validationErrors from "../../mixins/validationErrors";
import usersApis from "../../Apis/users";
import { getCurrentUserId } from "../../utils/auth";

export default {
  mixins: [validationErrors],
  components: {
    sidebarComponent,
  },
  data() {
    return {
      loader: true,
      status: null,
      errors: null,
      stripe_error: null,
      formObj: {
        user_id: getCurrentUserId(),
        card_number: null,
        card_expiry: null,
        card_cvv: null,
      },
    };
  },
  methods: {
    async WalletAction() {
      console.log(this.formObj);
      usersApis
        .addWallet(this.formObj)
        .then((response) => {
          console.log(response);
          if (response.status == 200 || response.status == 204) {
            this.status = { success: 200 };

            setTimeout(() => {
              this.$router.push({ name: "customer-wallets" });
            }, 2000);
          }
        })
        .catch((error) => {
          console.log(error.response);
          this.loader = false;
          if (is422(error)) {
            this.errors = error.response.data.errors;
          }
          this.status =
            error.response && error.response.status
              ? error.response.status
              : "";

          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            this.stripe_error = error.response.data.message;
          }
        })
        .then(() => {
          this.loader = false;
        });
    },
  },
  async created() {
    this.loader = false;
  },
};
</script>


// WEBPACK FOOTER //
// src/components/accounts/addUpdateWallet.vue